import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import EquityReleaseCalculator from "../../calculators/EquityReleaseCalculator";
import InheritanceTaxCalculator from "../../calculators/InheritanceTaxCalculator";

const InheritanceTaxPage = () => {
  return (
    <div>
      <Hero
        title="Inheritance Tax"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <InheritanceTaxCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default InheritanceTaxPage;
